import { useState } from "react";
import { Button, Input } from "reactstrap";

export default function PasswordPrompt({ onSuccess }) {
  const [Password, setPassword] = useState("");
  const correctPassword = "wcs$1212";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (Password === correctPassword) {
      sessionStorage.setItem("tube-auth", "true");   // 🔥 Store session login
      onSuccess();
    } else {
      alert("Incorrect Password"); // Toast is not correct in reactstrap
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "90vh" }}
    >
      <form
        onSubmit={handleSubmit}
        className="p-4 border rounded shadow"
        style={{ width: 300 }}
      >
        <h4 className="text-center mb-3">Enter Password</h4>

        <Input
          type="password"
          className="mb-3"
          placeholder="Password"
          value={Password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <Button type="submit" color="primary" outline className="w-100">
          Enter
        </Button>
      </form>
    </div>
  );
}
